package horcrux.frontend.common.views.components.loading

import horcrux.frontend.common.BooleanState
import mui.icons.material.Refresh
import mui.material.CircularProgress
import mui.material.CircularProgressColor
import mui.material.IconButton
import mui.material.IconButtonColor
import mui.material.IconButtonEdge
import mui.material.Size
import react.FC
import react.Props
import react.dom.aria.ariaLabel

external interface LoadingIconProps : Props {
    var onClick: (BooleanState) -> Unit
}

val LoadingIcon = FC<LoadingIconProps> { props ->
    val isLoadingState = BooleanState()
    IconButton {
        this.size = Size.large
        this.edge = IconButtonEdge.end
        this.color = IconButtonColor.inherit
        this.ariaLabel = "refresh-collections"
        this.onClick = {
            isLoadingState.setTrue()
            props.onClick(isLoadingState)
        }
        if (isLoadingState.get()) {
            CircularProgress {
                this.color = CircularProgressColor.inherit
                this.size = 24
            }
        } else {
            Refresh {}
        }
    }
}
